import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable, of } from 'rxjs';

export interface SiiaAttachmentLike {
  id?: string;
  text?: string;
  url?: string;
}

@Injectable()
export class SiiaAttachmentsService {
  constructor(private http: HttpClient) {}

  getAttachmentsFromRegisterElementCDT(
    entityId: string,
    cdt: string,
    documentType?: number
  ): Observable<SiiaAttachmentLike[]> {
    if (!entityId) {
      return of([]);
    }

    const aux: any = { idEntidade: entityId };
    if (cdt) {
      aux.cdt = cdt;
    }

    const params = new HttpParams({
      fromObject: aux,
    });

    if (documentType !== undefined && documentType !== null) {
      params.append('documentType', documentType);
    }

    return this.http
      .get<any[]>(`~SiiaUtils/GetEntityDocuments`, {
        params,
      })
      .pipe(
        map((res) => {
          return (
            res?.map<SiiaAttachmentLike>((x) => {
              return {
                id: x.attachmentId,
                text: x.name,
                url: x.url,
              };
            }) ?? []
          );
        })
      );
  }

  getAttachmentsFromAnnouncementId(
    accouncementId: string
  ): Observable<SiiaAttachmentLike[]> {
    if (!accouncementId) {
      return of([]);
    }

    return this.http
      .get<any[]>(`~SiiaUtils/GetConstructionAdDocuments`, {
        params: { id: accouncementId },
      })
      .pipe(
        map((res) => {
          return (
            res?.map<SiiaAttachmentLike>((x) => {
              return {
                id: x.attachmentId,
                text: x.name,
                url: x.url,
              };
            }) ?? []
          );
        })
      );
  }
}
